
<template>
    <!-- <div id="cst-survey" :style="this.layoutComputed"> -->
    <div id="cst-survey" :class="surveyClass" v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight">

        <app-loading-overlay v-if="loadingOverlay"></app-loading-overlay> 
        <div class="cst-survey-content-container">
            <div id="cst-survey-content" :class="surveyClass">
              <app-header :logo="hotelData.images.logo" :image="hotelData.images.header"></app-header>
              <app-modal /> 
              <div class="content-wrapper">
                <app-progress-bar :currentProgressPct="currentProgressPct"></app-progress-bar>
                <app-nav-bar :card_next="card_next" :card_prev="card_prev" :has_next_card="has_next_card" :has_previous_card="has_previous_card" :is_finished="is_finished">
                </app-nav-bar>
                <router-view></router-view>
              </div>
              <app-footer></app-footer>
            </div>
        </div>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    // import Router from 'vue-router'
    // import cst_survey from './components/CstSurvey'
    import './globals.js'
    import AppNavBar from './components/AppNavBar'
    import AppProgressBar from './components/AppProgressBar'
    import AppHeader from './components/AppHeader'
    import AppContent from './components/AppContent'
    import AppModal from './components/AppModal'
    import AppInit from './components/AppInit'
    import AppLoadingOverlay from './components/AppLoadingOverlay'
    import store from '@/components/store.js'
    import ArrowLeft from './components/ArrowLeft'
    import ArrowRight from './components/ArrowRight'
    import AppFooter from './components/AppFooter'
    import { generateStyleString } from './utils.js'
    import { i18n } from './components/i18n.js'

    export default {
      name: 'survey',
      data: function () {
        return {
          prechangeCBs: []
        }
      },
      computed: {
        current_card: function () {
          return this.$store.state.cards[this.$store.state.current_card_position]
        },
        has_next_card: function () {
          if (
            (
              this.current_card && (
                (this.current_card.skippable && this.current_card.skippable()) || (
                  this.current_card.content &&
                    (this.current_card.content.skippable && this.current_card.content.skippable())
                )
              )
            ) || this.$store.state.current_card_position + 1 < this.$store.state.cards.length
          ) {
            return true
          }
          return false
        },
        has_previous_card: function () {
          if (this.$store.state.current_card_position > 0) {
            return true
          }
          return false
        },
        is_finished: function () {
          return this.$store.state.is_survey_finished
        },
        hotelData: function () {
          return store.state.hotelData
        },
        loadingOverlay: function () {
          return store.state.loadingOverlay
        },
        currentProgressPct: function () {
          if (store.state.is_survey_finished) {
            return 100
          }
          return store.state.currentProgressPct
        },
        layoutComputed: function () {
          if (this.$store.state.hotelData.layout) {
            var cssValues = {}
            var layout = this.$store.state.hotelData.layout
            if (layout.background.color) {
              cssValues['background-color'] = layout.background.color.color
            } else if (layout.background.image) {
              cssValues['background-image'] = `url(${layout.background.image})`
              if (layout.background.position === 'scale') {
                cssValues['background-size'] = 'cover'
              }
              if (layout.background.position === 'tiling') {
                cssValues['background-repeat'] = 'repeat'
              }
              if (layout.background.position === 'center') {
                cssValues['background-position'] = 'top center'
                cssValues['background-repeat'] = 'no-repeat'
              }
            }
            return generateStyleString(cssValues)
          }
          return ''
        },
        needsOverflow: function () {
          return store.state.needsOverflow
        },
        surveyClass: function () {
          let obj = {
            'needs-overflow': this.needsOverflow
          }
          obj['cst-hotel-' + this.$store.state.hotelId] = 1
          return obj
        }
      },
      methods: {
        validateProgress: function () {
          if (this.current_card && this.current_card.validate && !this.current_card.validate()) {
            return false
          }
          return true
        },
        setLocale: function (locale_str) {
          i18n.locale = locale_str
        },
        swipeLeft: function () {
          if (this.has_next_card) {
            this.card_next()
          }
        },
        swipeRight: function () {
          if (this.has_previous_card) {
            this.card_prev()
          }
        },
        card_next: function () {
          this.$store.commit('setTransition', 'slide')
          eventHub.$emit('card-next')
          // if (this.$store.state.current_card_position + 1 < this.$store.state.cards.length) {
          //   this.$router.push({ name: 'card', params: { cardId: this.$store.state.current_card_position + 1 } })
          // } else {
          //   this.progress()
          // }
        },
        card_prev: function () {
          this.$store.commit('setTransition', 'reverseslide')
          this.$store.dispatch('removeCard').then(() => {
            this.$router.push({ name: 'card', params: { cardId: this.$store.state.current_card_position - 1 } })
          })
        },
        progress: function (replace = false) {
          if (!this.validateProgress()) {
            return
          }
          this.executePreChange().then(_ => {
            this.$store.commit('setTransition', 'slide')
            if ((this.$store.state.current_card_position + 1) < this.$store.state.cards.length) {
              this.$router.push({ name: 'card', params: { cardId: this.$store.state.current_card_position + 1 } })
            } else {
              if (this.$store.state.hasNextCard()) {
                var card_index = this.$store.state.setNextCard()
                // if( replace ) {
                //     this.$router.replace({ name: 'card', params: { cardId: this.$store.state.current_card_position + 1 }})
                // } else {
                this.$router.push({ name: 'card', params: { cardId: card_index } })
                // }
              }
            }
          })
          this.$store.dispatch('updateProgress')
        },
        postData: function (url, postData, overlayData, cb) {
          this.loadingOverlay = overlayData
          this.$store.dispatch('postData', postData).then(response => {
            cb(response)
            this.loadingOverlay = false
          }, error => {
            cb(error)
            this.loadingOverlay = false
          })
        },
        registerPreChange: function (cb) {
          this.prechangeCBs.push(cb)
        },
        executePreChange: function () {
          if (this.prechangeCBs.length) {
            return Promise.all([this.prechangeCBs[0]()]).then(_ => {
              this.prechangeCBs = []
            })
          } else {
            return Promise.all([])
          }
        }
      },
      created: function () {
        eventHub.$on('card-next', this.progress)
        eventHub.$on('post-data', this.postData)
        eventHub.$on('pre-change-register', this.registerPreChange)

        this.$store.dispatch('initSurvey').then(() => {
          this.progress(true)
        })
      },
      components: {
        AppHeader, AppProgressBar, AppContent, AppNavBar, AppModal, AppLoadingOverlay, AppInit, ArrowLeft, ArrowRight, AppFooter
      },
      watch: {
        '$route': function (route) {
          if (route.name === 'card') {
            this.$store.commit('setCardIndex', route.params.cardId * 1)
            this.$store.dispatch('updateProgress')
          }
        },
        'layoutComputed': function () {
          document.body.style.cssText = this.layoutComputed
        }
      }
    }
</script>

<style lang="less">
    @import '_theme';
    
    #cst-survey {
        width: 100%;
        min-height: 100%;
        display: flex;
        justify-content: center;
        font-family: 'Source Sans Pro', sans-serif;
        background-repeat: no-repeat;
        overflow: auto;
    }
    #cst-survey.needs-overflow {
      overflow: visible;
    }    
    #cst-survey-content.needs-overflow {
      overflow: visible;
    }

    #cst-survey-content {
        background-color: #fff;
        position: relative;
        border: 1px solid #ccc;
        border-bottom: none;
        display: flex;
        flex-direction: column;    
        overflow: hidden;
        box-shadow: 0.1em 0.1em 0.5em rgba(0,0,0,0.3);
    }
    .cst-survey-content-container {
        max-width: 800px;
        min-width: 360px;
        width: 90%;
        //overflow: visible;
    }
    
    #cst-survey-nav-right {
        width: 3.5em;
        align-items: center;
    }

    @media (max-width: 500px) {
      .cst-survey-content-container {
        width: 95%;
      }
    }

    @media (max-width: 800px) {
        #cst-survey {
            justify-content: center;
        }
        #cst-survey-content {
          min-height: 95%;
        }        
    }    
    // @media (min-width: 800px) {
    //      #cst-survey-content {
    //         box-shadow: rgba(204,204,204,0.7);
    //      }
    // }
    .content-wrapper {
      display: flex;
      flex-direction: column;
      flex-grow: 10;      
    }

</style>

<style>
 .cst-title {
     font-weight: bold;
     display: block;
     font-size: 1.3em;
 }
 body,html {
     margin: 0;
     padding: 0;
     height: 100%;
 }

 .cst-hotel-829 .cst-survey-header {
   height: 0 !important;
   padding-top: 18% !important;
   min-height: 0 !important;
   background-image: url(/static/header-satisfaction-survey.svg) !important;
}
</style>


// WEBPACK FOOTER //
// src/Survey.vue